/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPortfoliosHistoricalData} from '../api'

 export const useQueryGetPortfoliosHistoricalData = createReactQueryHook('getPortfoliosHistoricalData', getPortfoliosHistoricalData)
